import { useContext } from "react";

import {
    AuthContext,
    PaymentContext,
    AlertContext,
    SyncContext,
} from "../../context";

export const useAuth = () => useContext(AuthContext);
export const usePayment = () => useContext(PaymentContext);
export const useAlert = () => useContext(AlertContext);
export const useSync = () => useContext(SyncContext);
